// External imports
import { useEffect, useState } from 'react';
// Redux imports
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectSettings, setNotifications } from '../../features/application/appSlice';
// Components
import Notification from './Notification';
// Function and misc imports
import { FETCH_TIMER } from '../../utils/constants';

export const NotificationBar = (props: any) => {
  const dispatch = useAppDispatch();
  const notifications = useAppSelector((state) => state.app.notifications);
  const { notificationPosition } = useAppSelector(selectSettings);
  const status = notifications.message.replace('\n', `<br>`);
  const [statusArr, setStatusArr] = useState<{ time: number; message: string }[]>([]);

  useEffect(() => {
    let timer1: any;
    const time = Date.now();

    if (status !== '') {
      setStatusArr((statusArr) => {
        const newStatusArr = statusArr.filter((status) => status.time > time - FETCH_TIMER);
        return [...newStatusArr, { time: time, message: status }];
      });
    }
    timer1 = setTimeout(() => {
      setStatusArr([{ time: 0, message: '' }]);
      status !== '' && dispatch(setNotifications({ message: '' }));
    }, FETCH_TIMER);

    return () => {
      clearTimeout(timer1);
    };
    // eslint-disable-next-line
  }, [status]);

  // left: 15, 50, 85
  // top or bottom both at 0vh

  return (
    <div className="notification-bar-container" style={notificationPosition}>
      {statusArr
        ?.map(({ time, message }, index) => {
          if (message.length) {
            return <Notification key={time} time={time} status={message} />;
          } else return null;
        })
        .slice()
        .reverse()}
    </div>
  );
};

export default NotificationBar;
